import { render, staticRenderFns } from "./ShippingIntegrationPage.vue?vue&type=template&id=27d59045"
import script from "./ShippingIntegrationPage.vue?vue&type=script&lang=js"
export * from "./ShippingIntegrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports